// import AddIcon from '@material-ui/icons/Add';

import Button from '@material-ui/core/Button';

import Checkbox from '@material-ui/core/Checkbox';

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import Grid from '@material-ui/core/Grid';

import Paper from '@material-ui/core/Paper';

import React, { useEffect } from 'react';
// import RemoveIcon from '@material-ui/icons/Remove';

import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tableRightBorder : { borderWidth: 1, borderColor: 'black',borderStyle: 'solid'},
  tableRightBorderHeader : { borderWidth: 1, borderColor: 'white',borderStyle: 'solid'} 
}));

export default function Cervical() {
  const classes = useStyles();

  const defaultValue = JSON.parse(window.localStorage.getItem("nodeDefault"));
  const [nodeList, setNodeList] = React.useState(() => JSON.parse(window.localStorage.getItem("node")));    
  const [normalLymph, setNormalLymph] = React.useState(() => (window.localStorage.getItem("nodeNormal")==='true'));

  useEffect(() => {
      window.localStorage.setItem("node", JSON.stringify(nodeList));
      window.localStorage.setItem("nodeNormal", normalLymph ? 'true' : 'false');
      // console.log('window.localStorage.getItem("node") ', window.localStorage.getItem("node"));
      // console.log('window.localStorage.getItem("nodeNormal") ', window.localStorage.getItem("nodeNormal"));
  }, [nodeList, normalLymph]);

  function addNode(){
    if(nodeList.length === 32) return;
    var _nodeList = [...nodeList];
    var a = JSON.parse(JSON.stringify(defaultValue));
    _nodeList.push(a);
    setNodeList(_nodeList);
}

if(nodeList.length < 16){addNode();} // default: 4 nodes

// function removeNode(){    
//   if(nodeList.length === 1) return;
//   var _nodeList = [...nodeList];    
//   _nodeList.pop();
//   setNodeList(_nodeList);
// }

  return (
    <div className={classes.root}>
      <center>
        <Grid container spacing={24}>
            <Grid item xs={12} sm={12} container justify="flex-end">
                <Button variant="contained" color='secondary' startIcon={<DeleteOutlineIcon />} onClick={(event) => {
                    var _nodeList = [...nodeList];
                    _nodeList = [defaultValue];
                    setNormalLymph(true);
                    setNodeList(_nodeList);}} style={{backgroundColor:'#C71585', color:'white', marginBottom:'10px', zIndex:0}} >경부 림프 초기화</Button>
            </Grid>
        </Grid>  
      </center>
      <Grid container spacing={24}>
        <Grid item xs={12} sm={6}>
          {/* <Button variant="contained" color='primary' startIcon={<RemoveIcon />} style={{marginRight:'10px'}} onClick={removeNode} disabled={showReport || nodeList.length === 1}>Remove Node</Button> */}
          {/* <Button variant="contained" color='primary' startIcon={<AddIcon />} onClick={addNode} disabled={nodeList.length === 10}>Add Node</Button> */}
          </Grid>
          <Grid item xs={12} sm={6} container justify="flex-end">
            <TableBody>
                <TableCell align="left" size='small' className={classes.tableRightBorder}>
                    <FormControlLabel control={<Checkbox name="normal" 
                        defaultChecked={normalLymph} checked={normalLymph}
                        size='small'
                        onChange={(event) => { 
                            var _nodeList = [...nodeList];
                            setNormalLymph(event.target.checked);
                            setNodeList(_nodeList);
                        }}
                        color="primary"/>} label="Normal Lymph Node"/>
              </TableCell>
            </TableBody>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table" size="small" style={{marginTop:'10px'}}>
        <TableBody>
            <TableCell align="center" size="small" colSpan={9} style={{backgroundColor:"grey", color:'white'}}>Cervical Lymph Node Findings</TableCell>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell align="center" className={classes.tableRightBorder} rowSpan={2} >Location</TableCell>
            <TableCell align="center" className={classes.tableRightBorder} colSpan={4} >Lateral Neck</TableCell>
            <TableCell align="center" className={classes.tableRightBorder} colSpan={4} >Centeral Neck</TableCell>
          </TableRow>
          <TableRow>
              <TableCell align="center" className={classes.tableRightBorder} colSpan={2}>Right</TableCell>
              <TableCell align="center" className={classes.tableRightBorder} colSpan={2}>Left</TableCell>
              <TableCell align="center" className={classes.tableRightBorder} colSpan={2}>Right</TableCell>
              <TableCell align="center" className={classes.tableRightBorder} colSpan={2}>Left</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>Imaging Diagnosis</TableCell>
            {nodeList.slice(0,8).map((node, index) => 
              (index % 2) === 0 ?
              <TableCell align="center" className={classes.tableRightBorder} colSpan={1} >indeterminate</TableCell>
              :
              <TableCell align="center" className={classes.tableRightBorder} colSpan={1} >suspicious</TableCell>
            )}
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>Neck Level</TableCell>
            {nodeList.slice(0,8).map((node, index) =>    
              index < 4 ?
              <TableCell align="left" size="small" className={classes.tableRightBorder} colSpan={1}> 
                  <FormControlLabel control={<Checkbox name="normal" 
                      defaultChecked={node.neckLevel.level1}
                      disabled={normalLymph}
                      checked = {node.neckLevel.level1}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].neckLevel.level1 = event.target.checked;
                        if(_nodeList[index].neckLevel.level1){
                          _nodeList[index].location.neck = 'Lateral';
                          if(index < 2) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                        }
                        else{
                          _nodeList[index].location.neck = '';
                          _nodeList[index].location.position = '';
                        }
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="1"/>
                      <FormControlLabel control={<Checkbox name="normal" 
                      defaultChecked={node.neckLevel.level2}
                      disabled={normalLymph}
                      checked = {node.neckLevel.level2}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].neckLevel.level2 = event.target.checked;
                        if(_nodeList[index].neckLevel.level2){
                          _nodeList[index].location.neck = 'Lateral';
                          if(index < 2) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                        }
                        else{
                          _nodeList[index].location.neck = '';
                          _nodeList[index].location.position = '';
                        }
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="2"/>
                      <FormControlLabel control={<Checkbox name="normal" 
                      defaultChecked={node.neckLevel.level3}
                      disabled={normalLymph}
                      checked = {node.neckLevel.level3}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].neckLevel.level3 = event.target.checked;
                        if(_nodeList[index].neckLevel.level3){
                          _nodeList[index].location.neck = 'Lateral';
                          if(index < 2) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                        }
                        else{
                          _nodeList[index].location.neck = '';
                          _nodeList[index].location.position = '';
                        }
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="3"/>
                      <FormControlLabel control={<Checkbox name="normal" 
                      defaultChecked={node.neckLevel.level4}
                      disabled={normalLymph}
                      checked = {node.neckLevel.level4}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].neckLevel.level4 = event.target.checked;
                        if(_nodeList[index].neckLevel.level4){
                          _nodeList[index].location.neck = 'Lateral';
                          if(index < 2) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                        }
                        else{
                          _nodeList[index].location.neck = '';
                          _nodeList[index].location.position = '';
                        }
                        setNormalLymph(false); // when any input, disable normal lymph for all columns
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="4"/>
                      <FormControlLabel control={<Checkbox name="normal" 
                      defaultChecked={node.neckLevel.level5}
                      disabled={normalLymph}
                      checked = {node.neckLevel.level5}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].neckLevel.level5 = event.target.checked;
                        if(_nodeList[index].neckLevel.level5){
                          _nodeList[index].location.neck = 'Lateral';
                          if(index < 2) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                        }
                        else{
                          _nodeList[index].location.neck = '';
                          _nodeList[index].location.position = '';
                        }
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="5"/> 
              </TableCell>:
              <TableCell align="left" size="small" className={classes.tableRightBorder} colSpan={1}>
                  <FormControlLabel control={<Checkbox name="normal" 
                  defaultChecked={node.neckLevel.level6}
                  disabled={normalLymph}
                  checked = {node.neckLevel.level6}
                  size='small'
                  onChange={(event) => { 
                    var _nodeList = [...nodeList];
                    _nodeList[index].neckLevel.level6 = event.target.checked;
                    if(_nodeList[index].neckLevel.level6){
                      _nodeList[index].location.neck = 'Centeral';
                      if(index < 2) _nodeList[index].location.position = 'Right';
                      else _nodeList[index].location.position = 'Left';
                    }
                    else{
                      _nodeList[index].location.neck = '';
                      _nodeList[index].location.position = '';
                    }
                    setNormalLymph(false); // when any input, disable normal lymph for all columns 
                    setNodeList(_nodeList);
                  }}
                  color="primary"/>} label="6"/>
                  <FormControlLabel control={<Checkbox name="normal" 
                  defaultChecked={node.neckLevel.level7}
                  disabled={normalLymph}
                  checked = {node.neckLevel.level7}
                  size='small'
                  onChange={(event) => { 
                    var _nodeList = [...nodeList];
                    _nodeList[index].neckLevel.level7 = event.target.checked;
                    if(_nodeList[index].neckLevel.level7){
                      _nodeList[index].location.neck = 'Centeral';
                      if(index < 2) _nodeList[index].location.position = 'Right';
                      else _nodeList[index].location.position = 'Left';
                    }
                    else{
                      _nodeList[index].location.neck = '';
                      _nodeList[index].location.position = '';
                    }
                    setNormalLymph(false); // when any input, disable normal lymph for all columns 
                    setNodeList(_nodeList);
                  }}
                  color="primary"/>} label="7"/>
              </TableCell>
            )}
        </TableBody>
        <TableBody>
          <TableRow>
              <TableCell align="center" className={classes.tableRightBorder} rowSpan={1} style={{backgroundColor:'#FEF3BD'}}>* Largest lymph node diameter</TableCell>
              {nodeList.slice(0,8).map((node, index) => 
                <TableCell align="center" className={classes.tableRightBorder}>
                <div style={{marginTop:'10px'}}>  
                    LD (<TextField id="outlined-basic" size="small" disabled={normalLymph} inputProps={{style: { textAlign: 'center' }}} defaultValue={nodeList[index].diameter[0]} value={nodeList[index].diameter[0]}
                    onChange={(event) => {
                        var _nodeList = [...nodeList]; 
                        var multiplyForLocationPositionSetting = 1;
                        _nodeList[index].diameter[0] = event.target.value; 
                        if(index < 4) _nodeList[index].location.neck = 'Lateral';
                        else _nodeList[index].location.neck = 'Centeral';
                        if(_nodeList[index].diameter[0] !== ''){
                          if(index >= 4) multiplyForLocationPositionSetting = 3;                          
                          if(index < 2 * multiplyForLocationPositionSetting) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                          if(index % 2 === 0) _nodeList[index].imageDiag = 'indeterminate';
                          else _nodeList[index].imageDiag = 'suspicious';
                        }
                        else{
                          if(_nodeList[index].diameter[1] === ''){
                            _nodeList[index].location.neck = '';
                            _nodeList[index].location.position = '';
                            _nodeList[index].imageDiag = '';
                            _nodeList[index].diameter[2] = 'cm';
                            _nodeList[index].diameter[3] = 'cm';
                          }
                        }
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);} } style={{width:'30px'}}/>) &nbsp;
                        <select name="unit" disabled={normalLymph} value={nodeList[index].diameter[2]} onChange={(event) => {   
                            var _nodeList = [...nodeList];
                            _nodeList[index].diameter[2] = event.target.value;
                            // if(_nodeList[index].diameter[0] === '') _nodeList[index].diameter[2] = 'cm';
                            _nodeList[index].diameter[3] = _nodeList[index].diameter[2];
                            setNodeList(_nodeList);
                        }}>
                            <option value="cm">cm</option>
                            <option value="mm">mm</option>
                        </select>,
                        <br/>
                    SD (<TextField id="outlined-basic" size="small" disabled={normalLymph} inputProps={{style: { textAlign: 'center' }}} defaultValue={nodeList[index].diameter[1]} value={nodeList[index].diameter[1]}
                    onChange={(event) => {
                        var _nodeList = [...nodeList]; 
                        var multiplyForLocationPositionSetting = 1;
                        _nodeList[index].diameter[1] = event.target.value;
                        if(index < 4) _nodeList[index].location.neck = 'Lateral';
                        else _nodeList[index].location.neck = 'Centeral';
                        if(_nodeList[index].diameter[1] !== ''){
                          if(index >= 4) multiplyForLocationPositionSetting = 3;                          
                          if(index < 2 * multiplyForLocationPositionSetting) _nodeList[index].location.position = 'Right';
                          else _nodeList[index].location.position = 'Left';
                          if(index % 2 === 0) _nodeList[index].imageDiag = 'indeterminate';
                          else _nodeList[index].imageDiag = 'suspicious';
                        }
                        else{
                          if(_nodeList[index].diameter[0] === ''){
                            _nodeList[index].location.neck = '';
                            _nodeList[index].location.position = '';
                            _nodeList[index].imageDiag = '';
                            _nodeList[index].diameter[2] = 'cm';
                            _nodeList[index].diameter[3] = 'cm';
                          }
                        }
                        if(event.target.value) setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        else setNormalLymph(true);
                        setNodeList(_nodeList);} } style={{width:'30px'}}/>) &nbsp;
                        <select name="unit" disabled={normalLymph} value={nodeList[index].diameter[3]} onChange={(event) => {   
                            var _nodeList = [...nodeList];
                            _nodeList[index].diameter[3] = event.target.value;
                            // if(_nodeList[index].diameter[1] === '') _nodeList[index].diameter[3] = 'cm';
                            _nodeList[index].diameter[2] = _nodeList[index].diameter[3];
                            setNodeList(_nodeList);
                        }}>
                            <option value="cm">cm</option>
                            <option value="mm">mm</option>
                        </select>
                </div>
                </TableCell>
              )}
          </TableRow>
        </TableBody>
        
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>Comment</TableCell>
            {nodeList.slice(0,8).map((node, index) => 
                <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                    <TextField id="outlined-multiline-static" disabled={normalLymph} multiline rows={2} variant="outlined" style={{width:'100%'}} defaultValue={node.note} value={node.note} onChange={(event) => {
                        var _nodeList = [...nodeList];
                        _nodeList[index].note = event.target.value;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);}} />
                </TableCell>
            )}
        </TableBody>
        <TableBody>
            <TableCell align="center" size="small" style={{backgroundColor:"grey"}}></TableCell>
            <TableCell align="center" size="small" style={{backgroundColor:"grey", color:'white'}} colSpan={16}>Biopsy</TableCell>
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>Biopsy</TableCell>
            {nodeList.slice(0,8).map((node, index) =>
              <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                  <FormControlLabel control={<Checkbox name="ys" color="primary" disabled={normalLymph} size="small" defaultChecked={node.biopsy} checked={node.biopsy} 
                  onChange={(event) => { 
                    var _nodeList = [...nodeList];
                    _nodeList[index].biopsy = event.target.checked;
                    setNormalLymph(false); // when any input, disable normal lymph for all columns 
                    setNodeList(_nodeList);}}/>} label="Yes"/>
              </TableCell>
            )}
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>FNA</TableCell>
            {nodeList.slice(0,8).map((node, index) =>
              index < 4 ?
              <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                  <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph}
                      defaultChecked={node.FNA.level1}
                      checked = {node.FNA.level1}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level1 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="1"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph}
                      defaultChecked={node.FNA.level2}
                      checked = {node.FNA.level2}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level2 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="2"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.FNA.level3}
                      checked = {node.FNA.level3}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level3 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="3"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.FNA.level4}
                      checked = {node.FNA.level4}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level4 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="4"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.FNA.level5}
                      checked = {node.FNA.level5}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level5 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="5"/>
                    </TableCell>:
                    <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.FNA.level6}
                      checked = {node.FNA.level6}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level6 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="6"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.FNA.level7}
                      checked = {node.FNA.level7}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].FNA.level7 = event.target.checked;
                        _nodeList[index].FNA.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="7"/>
              </TableCell>
            )}
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>CNB</TableCell>
            {nodeList.slice(0,8).map((node, index) =>
              index < 4 ?
              <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                  <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level1}
                      checked = {node.CNB.level1}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level1 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="1"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level2}
                      checked = {node.CNB.level2}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level2 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="2"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level3}
                      checked = {node.CNB.level3}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level3 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="3"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level4}
                      checked = {node.CNB.level4}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level4 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="4"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level5}
                      checked = {node.CNB.level5}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level5 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="5"/>
                    </TableCell>:
                    <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level6}
                      checked = {node.CNB.level6}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level6 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="6"/>
                      <FormControlLabel control={<Checkbox name="normal" disabled={!node.biopsy || normalLymph} 
                      defaultChecked={node.CNB.level7}
                      checked = {node.CNB.level7}
                      size='small'
                      onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].CNB.level7 = event.target.checked;
                        _nodeList[index].CNB.checked = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                      }}
                      color="primary"/>} label="7"/>
              </TableCell>
            )}
        </TableBody>
        <TableBody>
            <TableCell align="center" className={classes.tableRightBorder}>Complications</TableCell>
            {nodeList.slice(0,8).map((node, index) =>
                <TableCell align="left" className={classes.tableRightBorder} colSpan={1}>
                    <FormControlLabel control={<Checkbox name="no" color="primary" size='small' disabled={node.complications.yes || !node.biopsy || normalLymph}
                    defaultChecked={node.complications.no} checked={node.complications.no} 
                    onChange={(event) => {
                        var _nodeList = [...nodeList];
                        _nodeList[index].complications.no = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList)}}/>} label="No"/>
                    <FormControlLabel control={<Checkbox name="ys" color="primary" size='small' disabled={node.complications.no || !node.biopsy || normalLymph}
                    defaultChecked={node.complications.yes} checked={node.complications.yes} onChange={(event) => { 
                        var _nodeList = [...nodeList];
                        _nodeList[index].complications.yes = event.target.checked;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList);
                    }}/>} label="Yes"/>
                    <TextField disabled={!node.complications.yes || normalLymph} defaultValue={node.complications.valueInput} value={node.complications.valueInput} onChange={(event) => {
                        var _nodeList = [...nodeList];
                        _nodeList[index].complications.valueInput = event.target.value;
                        setNormalLymph(false); // when any input, disable normal lymph for all columns 
                        setNodeList(_nodeList); }}
                    size="small" style={{width:'80px'}} inputProps={{style: { textAlign: 'center' }}}/>
                </TableCell>
            )}
        </TableBody>
      </Table>
    </TableContainer>
    <Grid container spacing={24}>
      <Grid item xs={12} sm={12} container justify="flex-end">
          <Button variant="contained" color='secondary' startIcon={<DeleteOutlineIcon />} onClick={(event) => {
            var _nodeList = [...nodeList];
            _nodeList = [defaultValue];
            setNormalLymph(true);
            setNodeList(_nodeList);}} style={{backgroundColor:'#C71585', color:'white', marginTop:'10px', zIndex:0}} >경부 림프 초기화</Button>
      </Grid>
    </Grid>
  </div>
  );
}